
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'BBCheckbox',
  emits: ['checkbox-changed'],
  props: {
    inputValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const classObject = computed(() => ({
      'bb-checkbox': true,
      'bb-checkbox--disabled': props.disabled,
      'bb-checkbox--dark': props.dark
    }))
    return {
      classObject
    }
  }
})
